import { GrFormClose } from 'react-icons/gr';
import './CloseIcon.scss';
const CloseIcon = ({ className }) => (
  <div className={`close-icon-container mr-4 ${className}`}>
    <GrFormClose size={40} color="#fffafe" />
  </div>
);

export default CloseIcon;
